import {
  HttpInterceptorFn
} from '@angular/common/http';

export const RequestInterceptor: HttpInterceptorFn = (req, next) => {
  console.log("RequestInterceptor", req.url);

  let newReq = req.clone({
    withCredentials: true,
  });

  return next(newReq);
}
